module.exports = __webpack_public_path__ + "img/img2.cb3aeff3.png";